import React from 'react';

const StepCard = ({
  icon,
  children
}) => {
  return (
    <div className="flex w-full min-h-[130px]">
      <div className="bg-primary900 flex p-[15px] pl-2 items-center rounded-tl-[10px] rounded-bl-[10px] border border-primary900 ">
        <img src={icon} className="w-[100px] h-auto" alt='tutorial icon' />
      </div>
      <div className="w-full rounded-tr-[10px] p-[10px] pl-[15px] rounded-br-[10px] border border-[#bfbfbf] border-l-0 text-[12px]">{children}</div>
    </div>
  )
}

export default StepCard;
